var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23333 32.5334C8.21667 32.5334 7.26667 32.1834 6.58333 31.5334C5.71667 30.7167 5.3 29.4834 5.45 28.15L6.06667 22.75C6.18333 21.7334 6.8 20.3834 7.51667 19.65L21.2 5.16671C24.6167 1.55004 28.1833 1.45004 31.8 4.86671C35.4167 8.28337 35.5167 11.85 32.1 15.4667L18.4167 29.95C17.7167 30.7 16.4167 31.4 15.4 31.5667L10.0333 32.4834C9.75 32.5 9.5 32.5334 9.23333 32.5334ZM26.55 4.85004C25.2667 4.85004 24.15 5.65004 23.0167 6.85004L9.33333 21.35C9 21.7 8.61667 22.5334 8.55 23.0167L7.93333 28.4167C7.86667 28.9667 8 29.4167 8.3 29.7C8.6 29.9834 9.05 30.0834 9.6 30L14.9667 29.0834C15.45 29 16.25 28.5667 16.5833 28.2167L30.2667 13.7334C32.3333 11.5334 33.0833 9.50004 30.0667 6.66671C28.7333 5.38337 27.5833 4.85004 26.55 4.85004Z",
    fill: "url(#paint0_linear_313_8266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 18.25C28.8667 18.25 28.8167 18.25 28.7833 18.25C23.5833 17.7334 19.4 13.7834 18.6 8.61671C18.5 7.93338 18.9667 7.30004 19.65 7.18337C20.3333 7.08337 20.9667 7.55004 21.0833 8.23338C21.7167 12.2667 24.9833 15.3667 29.05 15.7667C29.7333 15.8334 30.2333 16.45 30.1667 17.1334C30.0833 17.7667 29.5333 18.25 28.9 18.25Z",
    fill: "url(#paint1_linear_313_8266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37.9167H5C4.31667 37.9167 3.75 37.35 3.75 36.6667C3.75 35.9834 4.31667 35.4167 5 35.4167H35C35.6833 35.4167 36.25 35.9834 36.25 36.6667C36.25 37.35 35.6833 37.9167 35 37.9167Z",
    fill: "url(#paint2_linear_313_8266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_313_8266",
    x1: 3.75,
    y1: 18.4545,
    x2: 36.25,
    y2: 18.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_313_8266",
    x1: 3.75,
    y1: 18.4545,
    x2: 36.25,
    y2: 18.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_313_8266",
    x1: 3.75,
    y1: 18.4545,
    x2: 36.25,
    y2: 18.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarIcon);
export default __webpack_public_path__ + "static/media/editarIcon.b79de0e8251ce6e729fedacb74bfbf66.svg";
export { ForwardRef as ReactComponent };